import "@mantine/core/styles.css";
import { MantineProvider } from "@mantine/core";
import React from "react";
import { theme } from "./src/theme";

export const wrapPageElement = ({ element }) => (
  <MantineProvider theme={theme}>{element}</MantineProvider>
);